import { Link, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Barra superior con contacto */}
      <div className="bg-blue-600 text-white text-sm py-2">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div className="flex space-x-6">
            <a href="tel:0998106377" className="hover:text-blue-200 transition-colors">
              📞 099 810 6377
            </a>
            <span className="hidden sm:inline">📍 Pichincha y Zoila Victoria, Pujilí</span>
          </div>
          <div className="flex space-x-4">
            <span className="hidden md:inline">🕒 Lun-Dom 8AM-6PM</span>
            <a 
              href="https://wa.me/593998106377?text=Hola Betalink, me interesa información sobre la promoción de 3 meses" 
              className="hover:text-blue-200 transition-colors"
            >
              💬 WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Promoción destacada */}
      <div className="bg-yellow-400 text-gray-800 py-2">
        <div className="container mx-auto px-6 text-center">
          <p className="font-bold text-sm">
            🔥 ¡PROMOCIÓN 3 MESES! Desde 400 Mbps por solo $15.39 🔥
          </p>
        </div>
      </div>

      {/* Header principal */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center mr-3">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-blue-600">Betalink</h1>
                <p className="text-xs text-gray-500">Internet Ultra Rápido - Pujilí</p>
              </div>
            </Link>

            {/* Navegación Desktop */}
            <nav className="hidden md:flex space-x-8">
              <Link 
                to="/" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                🏠 Inicio
              </Link>
              <Link 
                to="/planes" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/planes') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                🎉 Planes Promocionales
              </Link>
              <Link 
                to="/servicios" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/servicios') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                ⚙️ Servicios
              </Link>
              <Link 
                to="/nosotros" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/nosotros') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                👥 Nosotros
              </Link>
              <Link 
                to="/contacto" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/contacto') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                📞 Contacto
              </Link>
              <Link 
                to="/speed-test" 
                className={`px-4 py-2 rounded-md transition-colors ${
                  isActive('/speed-test') 
                    ? 'text-blue-600 bg-blue-50 font-semibold' 
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                🚀 Test de Velocidad
              </Link>
              {/* ✅ ELIMINADO: Speed Test Pro del menú desktop */}
            </nav>

            {/* Botones de acción */}
            <div className="flex items-center space-x-4">
              <a 
                href="tel:0998106377"
                className="hidden sm:flex items-center text-blue-600 hover:text-blue-800 transition-colors font-semibold"
              >
                📞 099 810 6377
              </a>
              <Link 
                to="/planes"
                className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition-colors font-semibold"
              >
                🎉 ¡Promoción!
              </Link>
            </div>
          </div>

          {/* Navegación móvil */}
          <nav className="md:hidden mt-4 flex flex-wrap justify-center gap-2">
            <Link 
              to="/" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              Inicio
            </Link>
            <Link 
              to="/planes" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/planes') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              🎉 Promoción
            </Link>
            <Link 
              to="/servicios" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/servicios') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              Servicios
            </Link>
            <Link 
              to="/nosotros" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/nosotros') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              Nosotros
            </Link>
            <Link 
              to="/contacto" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/contacto') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              Contacto
            </Link>
            <Link 
              to="/speed-test" 
              className={`px-3 py-1 rounded text-sm transition-colors ${
                isActive('/speed-test') 
                  ? 'text-blue-600 bg-blue-50 font-semibold' 
                  : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
              }`}
            >
              🚀 Test
            </Link>
            {/* ✅ ELIMINADO: Speed Test Pro del menú móvil */}
          </nav>
        </div>
      </header>
    </>
  );
}

export default Header;